import React from 'react';
import PropTypes from 'prop-types';

import { SuiButton } from '@splashthat/sui';

import LogicBranchIcon from 'common/icons/LogicBranch';

const LOGIC_TITLE = 'Edit Logic';

export default function FixedControlLogic(props) {
    return (
        <SuiButton
            variation="navigation"
            size="small"
            icon={LogicBranchIcon}
            title={LOGIC_TITLE}
            aria-label={LOGIC_TITLE}
            onClick={props.onClick}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
        />
    );
}

FixedControlLogic.propTypes = {
    onClick: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
};
